import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { DeleteCoachService } from "../api";

const Delete = ({setOpenDelete1, fetchServicesList, selectedService}) => {
  const [pending, setPending] = useState(false);
  const [id, setId] = useState(null);

  useEffect(()=>{
    if(selectedService && selectedService._id){
      setId(selectedService._id);
    }
  }, [])
  const handleDelete = async () => {
    setPending(true);
    try{
      let res = await DeleteCoachService(id);
      fetchServicesList();
      setOpenDelete1()
    }catch(ex){
      console.log(ex);
    }finally{
      setPending(false)
    }
  }
  return (
    <>
      <div className="menu2  bg-white shadow-sm rounded-lg overflow-hidden">
        <div className="Abg-c d-flex justify-content-between align-items-start px-5 ">
          <div className="  py-5">
            <h1 className="font3">Delete Service</h1>
          </div>
          <button
            className="bg-transparent border-0 btnSize  pt-3"
            onClick={() => {
                setOpenDelete1(false);
            }}
            disabled={pending}
          >
            <RxCross2 />
          </button>
        </div>
        <div>
          <div className="d-flex justify-content-center pt-5 font-weight-bold">
            <p className="font3  w-50 text-center">
              Are you sure you want to delete this?
            </p>
          </div>

          <div className="px-5 py-5 ">
            <button className="form_btn" disabled={pending} onClick={() => {
                setOpenDelete1(false);
            }}>No,Cancel</button>
            <button disabled={pending} onClick={handleDelete} className='form_btn form_btn1 '>{pending ? <div style={{color: '#3783E7'}} class="spinner-border mx-auto" role="status"></div> : 'Yes,Delete'}</button>
            {/* <button className="form_btn ml-5  form_btn1 ">Yes,Delete</button> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Delete;
